import { FC, SVGProps } from 'react';

export const PaperPlaneIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M2.82742 12.95L13.1406 8.5416C13.2472 8.49631 13.3381 8.42076 13.402 8.32436C13.4659 8.22796 13.5 8.11495 13.5 7.99939C13.5 7.88383 13.4659 7.77082 13.402 7.67442C13.3381 7.57802 13.2472 7.50247 13.1406 7.45718L2.82742 3.04881C2.73812 3.00996 2.64052 2.9939 2.54344 3.00207C2.44636 3.01024 2.35285 3.04238 2.27133 3.0956C2.18982 3.14881 2.12288 3.22142 2.07654 3.30689C2.0302 3.39235 2.00593 3.48797 2.00591 3.58512L2 6.30205C2 6.59673 2.21868 6.85015 2.51418 6.88551L10.8652 7.99939L2.51418 9.10738C2.21868 9.14863 2 9.40206 2 9.69673L2.00591 12.4137C2.00591 12.8321 2.43735 13.1209 2.82742 12.95Z'
			fill='currentColor'
			fillOpacity='0.8'
		/>
	</svg>
);
